<template>
  <div>
    <dialog-manager />
    <snackbar-manager />
  </div>
</template>
<script setup>
import DialogManager from "@/app-services/DialogManager.vue";
import SnackbarManager from "@/app-services/SnackbarManager.vue";
import { useOutboundCallObserver } from "@/app-services/OutboundCallObserver.mjs";
import { useThemeManager } from "@/app-services/ThemeManager.mjs";
import { onBeforeUnmount, onMounted } from "vue";
import { useAuthEvents } from "@/util/auth-helper-service";
import { useRouter } from "vue-router";

useOutboundCallObserver();
useThemeManager();

const router = useRouter();

let authEvents;
onMounted(() => {
  authEvents = useAuthEvents(router);
});

onBeforeUnmount(() => {
  if (authEvents?.stopInterval) authEvents.stopInterval();
});
</script>
